import React from 'react';
import { Redirect, Stack } from 'expo-router';
import { Image, View } from 'react-native';
import { Text } from 'react-native-paper';
import { useSession } from '../../ctx/ctx';
import AppBar from '../../components/AppBar/AppBar';
import LoadingImage from '../../assets/loading.gif';
import Logo from '../../assets/logo.png';
import { MainContext } from '../../contexts/MainContext';

const Header = ({isHome, routeName}) => {
  const [title, setTitle] = React.useState('پنل مشاوران');

  React.useEffect(() => {
    switch (routeName) {
      case 'allAds':
        setTitle('همه آگهی‌ها');
      break;

      case 'myAds':
        setTitle('آگهی‌های من');
      break;

      case 'myRegion':
        setTitle('آگهی‌های تایید نشده');
      break;

      case 'transferredAds':
        setTitle('آگهی‌های ارجاع داده شده');
      break;

      case 'needUpdate':
        setTitle('آگهی‌های نیاز به بروزرسانی');
      break;

      case 'archivedAds':
        setTitle('آگهی‌های بایگانی شده');
      break;

      case 'allCustomer':
        setTitle('همه مشتری‌ها');
      break;

      case 'myCustomer':
        setTitle('مشتری‌های من');
      break;

      case 'inspection':
        setTitle('درخواست‌های کارشناسی');
      break;

      case 'propertyVisit':
        setTitle('درخواست‌های بازدید');
      break;

      case 'myVisitReport':
        setTitle('گزارش‌های بازدید');
      break;

      case 'profile':
        setTitle('پروفایل');
      break;

      case 'adds/index':
        setTitle('ثبت آگهی');
      break;

      case 'adds/[id]':
        setTitle('ویرایش آگهی');
      break;

      case 'customer/index':
        setTitle('ثبت مشتری');
      break;

      case 'customer/[id]':
        setTitle('ویرایش مشتری');
      break;

      case 'visitReport/index':
        setTitle('ثبت گزارش بازدید');
      break;

      case 'visitReport/[id]':
        setTitle('ویرایش گزارش بازدید');
      break;

      case 'search':
        setTitle('جستجو پیشرفته');
      break;

      case 'relatedAds/[id]':
        setTitle('آگهی‌های پیشنهادی');
      break;

      case 'relatedCustomer/[id]':
        setTitle('مشتری‌های پیشنهادی');
      break;
    
      default:
        setTitle('پنل مشاوران');
      break;
    }
  }, [routeName])

  return (
    <AppBar title={title} isHome={isHome} />
  )
}

export default function AppLayout() {
  const myContext = React.useContext(MainContext);
  const { session, isLoading } = useSession();

  // You can keep the splash screen open, or render a loading screen like we do here.
  if (isLoading) {
    return (
      <View style={{ height: '100%', backgroundColor: '#fff', justifyContent: 'space-between' }}>
        <View style={{ height: '87%', alignItems: 'center', justifyContent: 'center' }}>
          <Image source={Logo} style={{ width: 140, height: 101 }} />
        </View>
        <View style={{ height: '13%', alignItems: 'center', justifyContent: 'center' }}>
          <Text style={{ fontSize: 16, color: '#292D32', fontFamily: 'IRANSans_Bold' }}>پنل کارشناسان</Text> 
          <Image source={LoadingImage} style={{ width: 50, height: 50 }} />
        </View>
      </View>
    );
  }

  // Only require authentication within the (app) group's layout as users
  // need to be able to access the (auth) group and sign in again.
  if (!session) {
    // On web, static rendering will stop here as the user is not authenticated
    // in the headless Node process that the pages are rendered in.
    return <Redirect href="/sign-in" />;
  }

  // This layout can be deferred because it's not the root layout.
  return (
    <Stack screenOptions={{ header: (props) => <Header isHome={props.route.name === 'index' ? true: false} routeName={props.route.name} /> }} />
  );
}
